/** Human-friendly "time ago" label. Accepts a `Date` or epoch milliseconds. */
export function formatRelativeTime(input: Date | number): string {
  const ms = typeof input === 'number' ? input : input.getTime();
  const seconds = Math.round((Date.now() - ms) / 1000);
  if (seconds < 5) return 'just now';
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return new Date(ms).toLocaleDateString();
}
